import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../../service/auth/auth.service';
import {PopUpFilterDialogComponent} from '../pop-up-filter-dialog/pop-up-filter-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SearchFilterService} from '../../service/search/search-filter.service';
import {ScreenService} from '../../service/screen/screen.service';
import {BundeslandFilterService} from '../../service/bundeslandFilter/bundesland-filter.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent {

  breadcrumbToggle: boolean = false;
  @Input() sidenavToggle: boolean = true;
  @Output() onToggleSidenav: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onToggleBreadcrumbs: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public screenService: ScreenService,
              public authService: AuthService,
              public dialog: MatDialog,
              public bundeslandFilterService: BundeslandFilterService,
              private searchFilterService: SearchFilterService,
              private snackbar: MatSnackBar) {
  }

  public clickMenu() {
    this.sidenavToggle ? this.sidenavToggle = false : this.sidenavToggle = true;
    this.onToggleSidenav.emit(this.sidenavToggle);
  }

  public openFilterDialog() {
    const dialogRef = this.dialog.open(PopUpFilterDialogComponent, {
      width: '750px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.snackbar.open('Filter angewendet', 'OK');
    });
  }

  toggleBreadcrumbs() {
    this.breadcrumbToggle === true ? this.breadcrumbToggle = false : this.breadcrumbToggle = true;
    this.onToggleBreadcrumbs.emit(this.breadcrumbToggle);
  }
}
